module.exports = __webpack_public_path__ + "img/logo_bottom.8c98bf89.png";